import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles((theme) => ({
  fallbackImageContainer: {
    backgroundColor: theme.palette.neutralBackground,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  fallbackImage: {
    fill: theme.palette.neutralBorder,
  },
}));

export default useStyles;
